export * from './dom-ids';
export * from './pdf-options';
export * from './routes';
export * from './sizes';

// Since progress is made in multiple services + the browser,
// we have to count the number of total steps by hand
export const REPORT_GENERATION_TOTAL_STEPS = 21;
